import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import * as partnerApi from '../../../lib/api/partner';
import ParEmpForm from '../../../components/partnermng/employees/ParEmpForm';
import { useDispatch, useSelector } from 'react-redux';
import { listPartnerEmployees } from '../../../modules/partnerModule/employees';

const ParEmpFormContainer = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { partner } = useSelector(({ partnerModule, loading }) => ({
    partner: partnerModule.partner.partner,
  }));

  const initialValues = {
    employeeNm: '',
    employeeGrade: '',
    dutiesNm: '',
    telNo: '',
    emailAddr: '',
    employeeDesc: '',
  };

  const validationSchema = yup.object({
    employeeNm: yup.string('').required('담당자명을 입력하세요'),
    employeeGrade: yup.string().nullable('직급을 입력하세요'),
    dutiesNm: yup.string().nullable('담당업무를 입력하세요'),
    telNo: yup.string('').required("연락처를 입력하세요"),
    emailAddr: yup.string().email('이메일 형식이 아닙니다').required("이메일을 입력하세요"),
    employeeDesc: yup.string().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      let dataToSubmit = {
        employeeNm: values.employeeNm,
        employeeGrade: values.employeeGrade,
        dutiesNm: values.dutiesNm,
        telNo: values.telNo,
        emailAddr: values.emailAddr,
        employeeDesc: values.employeeDesc,
      };

      try {
        const response = await partnerApi.addPartnerEmp(
          partner.partnerUuid,
          dataToSubmit,
        );
        if (response.data) {
          dispatch(listPartnerEmployees(partner.partnerUuid));
          enqueueSnackbar("거래처 담당자가 추가되었습니다.", {
            variant: 'success',
          });
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

      formik.resetForm();
      setSubmitting(false);
    },
  });

  return <ParEmpForm formik={formik} />;
};

export default ParEmpFormContainer;
